export default "__VITE_ASSET__BTiKlZOr__"